export default {
    isWorkerBulkEditDialogOpen: false,
    selectedBulkEditWorkerCodeList: [],
};
